import React from "react";
import { Badge } from "react-bootstrap";

export const RenderPerformanceMetric = (cell) => {
    const value = cell.value || 0;

    let chipColor = "secondary"; 
    let textColor = "light";

    if (value > 90) {
        chipColor = "danger"; 
    }
    else if (value > 75) {
        chipColor = "warning"; 
        textColor = "dark";
    }
    else if (value > 50) {
        chipColor = "info"; 
    }
    else chipColor = "success"; 

    return <Badge text={textColor} bg={chipColor}>{`${(Math.round(value * 100) / 100).toFixed(2)}%`}</Badge>;
};